import { FC } from "react"

import { classNames } from "../../../utils"
import { LoUploadStatus } from "../../../../types"

interface MemberCellProps {
  value: string
  status: LoUploadStatus
  className?: string
}

const MemberCell: FC<MemberCellProps> = ({
  value,
  status,
  className = "py-4 px-3 text-sm text-gray-500"
}) => (
  <td
    className={classNames(
      `whitespace-nowrap transition-colors truncate ${className}`,
      {
        "bg-green-50 text-teal-800": status === "success",
        "bg-red-50 text-red-800": status === "error",
        "animate-pulse": status === "pending"
      }
    )}
  >
    {value}
  </td>
)

export default MemberCell
